// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DownloadDetailsList.css */

.download-details-container {
  padding: 1rem;
  font-family: Arial, sans-serif;
}

.download-details-container h2 {
  margin-bottom: 1rem;
}

.download-table {
  width: 100%;
  border-collapse: collapse;
}

.download-table th,
.download-table td {
  border: 1px solid #ccc;
  padding: 0.5rem;
  text-align: center;
}

.download-table th {
  background-color: #f5f5f5;
}

.download-table tbody tr:nth-child(odd) {
  background-color: #fff;
}

.download-table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.d-toggle-btn {
  padding: 0.25rem 0.5rem;
  background-color: #848586;
  color: #fff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.toggle-btn:hover {
  background-color: #6a6a6b;
}

.expanded-content {
  background-color: #f9f9f9;
  padding: 1rem;
}

.line-items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;
}

.line-items-table th,
.line-items-table td {
  border: 1px solid #ddd;
  padding: 0.4rem;
}

.line-items-table th {
  background-color: #e9e9e9;
}

.order-details {
  margin: 1%;
}

.other-info-list {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(4, minmax(20%, 1fr));
  margin-top: 1rem;
  list-style: none;
  padding: 0;
}

.other-info-list li {
  margin: 1rem;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateProjects/DownloadDetailsList.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kDAAkD;EAClD,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["/* DownloadDetailsList.css */\n\n.download-details-container {\n  padding: 1rem;\n  font-family: Arial, sans-serif;\n}\n\n.download-details-container h2 {\n  margin-bottom: 1rem;\n}\n\n.download-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.download-table th,\n.download-table td {\n  border: 1px solid #ccc;\n  padding: 0.5rem;\n  text-align: center;\n}\n\n.download-table th {\n  background-color: #f5f5f5;\n}\n\n.download-table tbody tr:nth-child(odd) {\n  background-color: #fff;\n}\n\n.download-table tbody tr:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.d-toggle-btn {\n  padding: 0.25rem 0.5rem;\n  background-color: #848586;\n  color: #fff;\n  border: none;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n.toggle-btn:hover {\n  background-color: #6a6a6b;\n}\n\n.expanded-content {\n  background-color: #f9f9f9;\n  padding: 1rem;\n}\n\n.line-items-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 0.5rem;\n}\n\n.line-items-table th,\n.line-items-table td {\n  border: 1px solid #ddd;\n  padding: 0.4rem;\n}\n\n.line-items-table th {\n  background-color: #e9e9e9;\n}\n\n.order-details {\n  margin: 1%;\n}\n\n.other-info-list {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(4, minmax(20%, 1fr));\n  margin-top: 1rem;\n  list-style: none;\n  padding: 0;\n}\n\n.other-info-list li {\n  margin: 1rem;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
